var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessagesSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_1693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1318 19.0075L16.9989 17M7.6602 21.0974L9.29851 19.9503M9.95451 24.374L11.5928 23.2269M10.4736 12.1206L22.8921 10.276C24.8321 9.98782 26.2673 12.0375 25.333 13.7619L19.3522 24.8005C18.2885 26.7638 15.3507 26.3153 14.9238 24.1244L14.1537 20.1716C14.025 19.5109 13.6223 18.9357 13.0454 18.5888L9.59442 16.5132C7.68164 15.3628 8.26492 12.4487 10.4736 12.1206Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_1693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.287109 14.0531) rotate(-35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesSend);
export default __webpack_public_path__ + "static/media/messages-send.276a3801582ccd8d405a4e852e2a6137.svg";
export { ForwardRef as ReactComponent };